"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBaseLinkedSteps = appBaseLinkedSteps;
/** The steps of a `linkedFrom`, the outermost first. */
function appBaseLinkedSteps(linked) {
    const steps = [linked];
    for (let step = linked; 'linkedFrom' in step; step = step.linkedFrom)
        steps.push(step.linkedFrom);
    return steps;
}
